import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IAppDashboardHeaderProps {
  activatedAt: string
  userName: string
}

export const AppDashboardHeader: React.FC<IAppDashboardHeaderProps> = ({
  activatedAt,
  userName,
}) => {
  const { t } = useTranslation()
  const isActivatedToday = moment().isSame(moment(activatedAt), 'day')
  return (
    <div className="space-y-2 mt-4 lg:mt-0">
      <h3 className="font-medium text-2xl font-inter">{`${
        isActivatedToday ? t('commandCenter.greetingNew') : t('commandCenter.greetingReturning')
      }, ${userName}!`}</h3>
      <p className="font-normal font-inter text-sm text-app-grey-70">
        {t('commandCenter.recentActivitySubtitle')}
      </p>
    </div>
  )
}
